import React, { useState } from 'react';
import { FiChevronRight, FiLayers } from 'react-icons/fi';

const Accordion = ({ title, onToggle, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleToggle = () => {
        // If this is the first time opening, call the onToggle function to fetch content
        if (!isOpen && onToggle) {
            onToggle();
        }
        setIsOpen(!isOpen);
    };

    return (
        <div className="accordion-item">
            <button className="accordion-header" onClick={handleToggle}>
                <div className="accordion-title">
                    <FiLayers className="accordion-icon" />
                    <span>{title}</span>
                </div>
                <FiChevronRight className={`accordion-chevron ${isOpen ? 'open' : ''}`} />
            </button>
            <div className={`accordion-content ${isOpen ? 'open' : ''}`}>
                <div className="accordion-content-inner">
                    {isOpen ? children : null}
                </div>
            </div>
        </div>
    );
};

export default Accordion;